import React, { Component } from 'react'

export class Galery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [
        { id: 1, src: './img/gallery/photo1.jpeg', alt: 'Галерея 1' },
        { id: 2, src: './img/gallery/photo2.jpg', alt: 'Галерея 2' },
        { id: 3, src: './img/gallery/photo3.jpeg', alt: 'Галерея 3' },
        { id: 4, src: './img/gallery/photo4.jpeg', alt: 'Галерея 4' },
        { id: 5, src: './img/gallery/photo5.jpeg', alt: 'Галерея 5' },
        { id: 6, src: './img/gallery/photo6.jpeg', alt: 'Галерея 6' },
        { id: 7, src: './img/gallery/photo7.jpeg', alt: 'Галерея 7' },
        { id: 8, src: './img/gallery/photo8.jpeg', alt: 'Галерея 8' },
        { id: 9, src: './img/gallery/photo9.jpeg', alt: 'Галерея 9' }, 
      ]
    };
  }

  render() {
    return (
      <div className='gallery-total'>

      <h1>Галерея</h1>
      <div className='galery-section'>
        <div className='gallery-grid'>
          {this.state.images.map(image => (
            <div key={image.id} className='gallery-item'>
              <img src={image.src} alt={image.alt} />
            </div>
          ))}
        </div>
      </div>
      </div>
    )
  }
}

export default Galery